import { callApi } from "../../lib/utils";
import { DEVICE_TYPES } from "./mockData";

export const getAcumaAppType = (deviceType) =>
  deviceType === DEVICE_TYPES.WATCH ? "W" : "M";

const getPayload = (response) => response?.data?.data ?? response?.data ?? {};

const getCodePayloadFromResponse = (response) => {
  const payload = getPayload(response);
  return {
    code: payload.code != null ? String(payload.code) : null,
    expiresInSeconds: payload.expiresInSeconds ?? null,
    expiresAt: payload.expiresAt ?? null,
    reused: payload.reused ?? false,
  };
};

const getStatusFromResponse = (response) => {
  const payload = getPayload(response);
  return payload.status ?? null;
};

export const fetchWatchSignInCodeStatus = (patientId) =>
  callApi(
    `/api/admin/patient/${patientId}/watch-signin-code/status`,
    {},
    "GET"
  ).then((response) => getStatusFromResponse(response));

export const fetchWatchSignInCode = (patientId, force = false) =>
  callApi(
    `/api/admin/patient/${patientId}/watch-signin-code`,
    { force },
    "POST"
  ).then((response) => getCodePayloadFromResponse(response));

export const fetchLatestDevice = (acumaAppType) =>
  callApi(
    `/api/web/patient/device/latest?acumaAppType=${encodeURIComponent(
      acumaAppType
    )}`,
    {},
    "GET"
  ).then((response) => getPayload(response));

export const pingDevice = (acumaAppType) =>
  callApi(
    `/api/web/patient/device/ping?acumaAppType=${encodeURIComponent(
      acumaAppType
    )}`,
    {},
    "POST"
  ).then((response) => ({
    message:
      response?.data?.message ||
      response?.data?.data?.message ||
      "Request processed successfully!",
    success: response?.data?.success,
    data: getPayload(response),
  }));

export const fetchDevicePermissions = ( acumaAppType) =>
  callApi(
    `api/web/patient/app-permissions/?acumaAppType=${encodeURIComponent(
      acumaAppType
    )}`,
    {},
    "GET"
  ).then((response) => {
    const payload = getPayload(response);
    return payload?.permissions ?? payload ?? [];
  });
